import React from "react";

import Image from "../../components/image";
import BackFlowerIllustration from "../../images/illustrations/back-flower.inline.svg";
import MountainIllustration from "../../images/illustrations/Mountain_illustration.inline.svg";
import { Link } from "../../utils/customLink";
import { DesktopTabletOnly } from "../base/wrapper/device";
import { FullwidthBannerBGImage } from "../shared/fullwidthBannerBGImage";

const TextWideImage = ({
  img,
  sourceUrl,
  btnLabel,
  btnUrl,
  brandMessageBanner = {}
}) => {
  return (
    <>
      {(img || sourceUrl || brandMessageBanner?.genBrandMessageImage) && (
        <section className="relative flex items-center justify-center px-4 md:px-0 bg-yellow-lighter dark:bg-gray-darkest overflow-hidden">
          <DesktopTabletOnly>
            <BackFlowerIllustration className="absolute hidden dark:block md:w-1/3 -left-[54%] md:left-[75vw] -bottom-[115%] md:-bottom-[25vw] -scale-x-100 stroke-white" />
            <MountainIllustration className="!absolute dark:hidden w-[150%] md:w-1/2 -left-[15vw] md:-left-[11vw] top-[90vw] md:top-[4vw] -scale-x-100 xl:w-2/5" />
          </DesktopTabletOnly>
          <div className="container text-center z-10 w-full md:w-4/5 py-16 md:py-20">
            <div className="relative">
              {brandMessageBanner?.genBrandMessageTitle ? (
                <FullwidthBannerBGImage
                  bannerTitle={brandMessageBanner?.genBrandMessageTitle}
                  bannerSubTitle={brandMessageBanner?.genBrandMessageSubtitle}
                  imageSrc={brandMessageBanner?.genBrandMessageImage}
                  bannerTitleClass={
                    "banner-heading leading-tight dark:leading-snug h1 xxs:text-white sm:text-black-lighter dark:sm:text-white !font-normal dark:!font-semibold text-left pb-3"
                  }
                  subTitleClass={
                    "banner-heading no-br sm:show-br h2 leading-tight dark:leading-snug h1 xxs:text-white sm:text-black-lighter dark:sm:text-white !font-normal dark:!font-light text-left"
                  }
                  bannerOuterContainerClass="relative z-20 flex justify-center items-center px-7 sm:px-0 mt-10 sm:mt-0 mb-10 sm:mb-0 w-full h-full"
                  showGradient={false}
                  bgImageClass="h-84 sm:h-full w-full object-cover object-center"
                  containerClass="sm:px-4 sm:py-12 bg-yellow-standard dark:gvi-light-gray-bg  h-full sm:h-96"
                />
              ) : (
                <>
                  <Image
                    image={img}
                    // imageAlt={title}
                    sourceUrl={sourceUrl}
                    imageClass={
                      "object-cover object-center w-full h-[340px] rounded-xxs"
                    }
                  />

                  {btnUrl && (
                    <Link
                      className="absolute top-0 bottom-0 right-0 left-0"
                      to={btnUrl}
                    />
                  )}
                </>
              )}
            </div>

            {btnUrl && (
              <div className="mt-14 w-full flex flex-col items-center justify-center m-auto">
                <Link
                  to={btnUrl}
                  target={"gvi_blank"}
                  className="submit-button px-7 py-2 w-full cursor-pointer sm:w-1/5"
                >
                  {btnLabel}
                </Link>
              </div>
            )}
          </div>
        </section>
      )}
    </>
  );
};

export default TextWideImage;
